import { textIn, type LayoutDocument } from './types'

/** The playing playlist's ticker lines in the screen's language: the first media area's, empty ones left out. */
export function tickerLines(doc: LayoutDocument, lang: string): string[] {
  const media = doc.elements.find((el) => el.kind === 'media' && (el.media?.ticker?.length ?? 0) > 0)?.media
  return (media?.ticker ?? []).map((line) => textIn(line, lang).trim()).filter((s) => s !== '')
}

/** A ticker's own text as lines, blank ones left out (layout.SplitTickerLines). */
export function tickerLinesOf(text: string | undefined): string[] {
  return (text ?? '').split('\n').map((line) => line.trim()).filter((line) => line !== '')
}

/** How long one pass of a ticker takes: about five characters a second, never under twelve seconds. */
export function tickerSeconds(text: string): number {
  return Math.max(12, Math.round(text.length / 5))
}

/** Whether a board's own badge moves to the top: a ticker runs along the bottom tenth, and none along the top. */
export function chromeAtTop(doc: LayoutDocument): boolean {
  const tickers = doc.elements.filter((el) => el.kind === 'ticker')
  const H = doc.canvas.height
  return tickers.some((el) => el.y + el.h > H * 0.9) && !tickers.some((el) => el.y < H * 0.1)
}
